
import { axios, BaseApiUrl ,BaseUrl} from '../axios_config';


export function GetInventoryList(params) {
    return axios.post(`${BaseApiUrl}/InventoryReport/GetInventoryList`, params);
}

export const InventoryExport = `${BaseApiUrl}/InventoryReport/InventoryExport`;



//查询占用箱状态
export const getInventoryBatchBoxStatus = params => {
    return axios.get(`${BaseApiUrl}/InventoryReport/GetInventoryBatchBoxStatus`, { params: params });
};

//查询在库箱明细
export function getInventoryBatchBoxGauge(params) {
    return axios.post(`${BaseApiUrl}/InventoryReport/GetInventoryBatchBoxGauge`, params);
};
//导出在库箱明细

export const inventoryBatchBoxGaugeExport = `${BaseApiUrl}/InventoryReport/InventoryBatchBoxGaugeOut`;
